module.exports = __webpack_public_path__ + "static/media/loading2.3da66db1.gif";